const path = "/rh/servidor";
const pathMatricula = "/rh/matricula";
export default {
  main: path,
  matricula: pathMatricula,
  busca: `${path}/buscar`,
};
